import { createSelector } from 'reselect';
import find from 'lodash/find';
import map from 'lodash/map';
import sum from 'lodash/sum';
import buildPropertyCardsData from 'lib/search/buildPropertyCardsData';
import mapDealsToCategories from 'lib/search/mapDealsToCategories';

export const getActiveCategory = (state) => state.promoArea.activeCategory;
export const getComponentState = (state) => state.promoArea.componentState;
export const getResults = (state) => state.promoArea.deals;
export const getIsLoading = (state) => state.promoArea.isLoading;
export const getHasResults = createSelector(getResults, (results) => {
  const totalResultsCount = sum(map(results, (category) => category.results.length));

  /**
   * Note: The total has to be greater than one, as we don't display with one result
   */
  return totalResultsCount > 1;
});

const getCategorisedResults = createSelector(getResults, mapDealsToCategories);

export const getCategories = createSelector(getCategorisedResults, (results) => results.map((result) => result.type));
export const getResultsForActiveCategory = createSelector(getCategorisedResults, getActiveCategory, (results, activeCategory) => {
  const categoryResults = find(results, ['type.code', activeCategory.code]);

  if (!categoryResults?.results) return [];

  const firstDeals = categoryResults.results.slice(0, 3);
  const result = buildPropertyCardsData({ results: firstDeals });

  return result;
});
